module.exports = __webpack_public_path__ + "static/media/details-21-image-5.2db8a25f.jpg";